import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { formatCalendarDate, toCalendarDate } from '../helpers/calendar-date.utils';

@Pipe({
  name: 'timezoneTransform',
  standalone: false
})
export class TimezoneTransformPipe implements PipeTransform {
  private datePipe: DatePipe = new DatePipe('en-US');

  transform(value: any, format: string = 'yyyy-MM-dd', timezone?: string): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    // Saved custom dates are calendar days. Keep that day instead of shifting it
    // through the system timezone or logged-in user timezone.
    if ((typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) || value instanceof Date) {
      return formatCalendarDate(value, format);
    }

    const dateValue = toCalendarDate(value);
    if (!dateValue) {
      return '';
    }

    const targetTimezone = timezone || 'America/New_York';

    try {
      return this.datePipe.transform(dateValue, format, targetTimezone) || '';
    } catch (error) {
      console.error('Error transforming date with timezone:', error);
      try {
        return this.datePipe.transform(dateValue, format) || '';
      } catch {
        return '';
      }
    }
  }
}
